// Kept apart from pdfImporter so the UI can mention the limit without pulling
// the importer (and pdf-lib) into the initial bundle.
export const MAX_IMPORT_BYTES = 25 * 1024 * 1024
